import CustomBlock from './CustomBlock';

export default CustomBlock;
